// extracted by mini-css-extract-plugin
export default {"loadercont":"Loader1_loadercont__d8VcZ","loader":"Loader1_loader__YJbOt","l15":"Loader1_l15__EkGr3"};